import * as o from "react";
import e from "../lib/IconBase.es.js";
import s from "../defs/PaintBrush.es.js";
const r = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(e, { ref: a, ...t, weights: s }));
r.displayName = "PaintBrushIcon";
const m = r;
export {
  m as PaintBrush,
  r as PaintBrushIcon
};
